import type { DetectionProfile } from '../core/types';

export const genericRotaryWingProfile: DetectionProfile = {
  id: 'generic-rotary-wing',
  version: '1.0.0',
  label: 'Generic Rotary-Wing Demonstration',
  description:
    'Synthetic, illustrative rotary-wing telemetry profile. Not approved for operational use.',
  synthetic: true,
  dataClassification: 'SYNTHETIC_UNCLASSIFIED',
  platformCategory: 'generic-rotary-wing',
  expectedCadenceMs: 500,
  cadenceToleranceMs: 125,
  staleAfterMs: 2_500,
  sequencePolicy: 'required',
  channels: {
    altitude: {
      channel: 'altitude',
      label: 'Altitude',
      unit: 'ft',
      required: true,
      minimum: 0,
      maximum: 20_000,
    },
    airspeed: {
      channel: 'airspeed',
      label: 'Airspeed',
      unit: 'kts',
      required: true,
      minimum: 0,
      maximum: 250,
    },
    rotorSpeed: {
      channel: 'rotorSpeed',
      label: 'Rotor Speed',
      unit: 'rpm',
      required: true,
      minimum: 0,
      maximum: 600,
    },
    fuel: { channel: 'fuel', label: 'Fuel', unit: '%', required: true, minimum: 0, maximum: 100 },
  },
  rules: [
    {
      id: 'rotary.range.altitude',
      kind: 'range',
      label: 'Altitude range',
      description: 'Synthetic demonstration range.',
      severity: 'error',
      enabled: true,
      channel: 'altitude',
      minimum: 0,
      maximum: 20_000,
    },
    {
      id: 'rotary.range.airspeed',
      kind: 'range',
      label: 'Airspeed range',
      description: 'Synthetic demonstration range.',
      severity: 'error',
      enabled: true,
      channel: 'airspeed',
      minimum: 0,
      maximum: 250,
    },
    {
      id: 'rotary.range.rotor-speed',
      kind: 'range',
      label: 'Rotor-speed range',
      description: 'Synthetic demonstration range.',
      severity: 'error',
      enabled: true,
      channel: 'rotorSpeed',
      minimum: 0,
      maximum: 600,
    },
    {
      id: 'rotary.range.fuel',
      kind: 'range',
      label: 'Fuel range',
      description: 'Synthetic demonstration range.',
      severity: 'error',
      enabled: true,
      channel: 'fuel',
      minimum: 0,
      maximum: 100,
    },
    {
      id: 'rotary.rate.altitude',
      kind: 'rate',
      label: 'Altitude rate',
      description: 'Time-based change check.',
      severity: 'warning',
      enabled: true,
      channel: 'altitude',
      maximumAbsoluteRate: 150,
    },
    {
      id: 'rotary.rate.rotor-speed',
      kind: 'rate',
      label: 'Rotor-speed rate',
      description: 'Time-based change check.',
      severity: 'warning',
      enabled: true,
      channel: 'rotorSpeed',
      maximumAbsoluteRate: 80,
    },
    {
      id: 'rotary.frozen.rotor-speed',
      kind: 'frozen',
      label: 'Frozen rotor-speed sensor',
      description: 'Sustained unchanged channel.',
      severity: 'warning',
      enabled: true,
      channel: 'rotorSpeed',
      minimumDurationMs: 5_000,
      tolerance: 0.01,
    },
  ],
};
